module.exports = __webpack_public_path__ + "static/media/HRT.cb0c2623.jpg";